
import { toMoney } from '@/utils/validate'
import TitleBox from '@/components/CSS/TitleBox'
import NumberVerify from '@/components/NumberVerify'
import md5 from 'js-md5'
import { mapGetters } from 'vuex'

export default {
    components: {
        TitleBox,
        NumberVerify
    },
    computed: {
        ...mapGetters({
            userAccount: 'user/userAccount',
            userAccountAlipay: 'user/userAccountAlipay',
            userinfo: 'user/userinfo',
            checkPayPass: 'user/checkPayPass'
        }),
        realPrice() {
            return parseFloat(this.ruleFrom.amount) - parseFloat(this.withdrawalFeePrice)
        }
    },
    data() {
        const validateAmount = (rule, value, callback) => {
            if (!+value) {
                callback(new Error('请输入提现金额'))
            } else if (value > this.userAccount.balanceAmount) {
                callback(new Error('超过可提现金额'))
            } else {
                callback()
            }
        }
        return {
            accountAlipayData: {},
            submitLoading: null,
            tixianLoading: null,
            withdrawalFeePrice: null,
            value: null,
            ruleFrom: {
                amount: null
            },
            rules: {
                amount: [{ required: true, validator: validateAmount, trigger: 'blur' }]
            },
            dialogVisible: false,
            dialogVisibles: false
        }
    },
    methods: {
        isRealName() {
            // 先判断有没有实名
            if (!this.userinfo.isRealName) {
                this.$message.info('完成实名认证后再进行添加账户')
                // window.localStorage.setItem("realPath", this.$route.path);
                this.$router.push('/account/authHome')
                return
            }
            // 然后判断有没有设置支付密码
            if (!this.checkPayPass) {
                this.$message.warning('请设置支付密码')
                this.$router.push('/account/setPayPassword')
                return
            }
            // 否则就通过前往添加账户
            this.$router.push('/account/addTiXianAccount')
        },
        back() {
            this.$router.go(-1)
        },
        toMoneyHandler(num) {
            return toMoney(num)
        },
        completedAuthentication(v) {
            if (v.length === this.$enum.payPassLength) {
            }
        },
        completed(v) {
            if (v.length === this.$enum.payPassLength) {
                let p = {
                    action: {
                        amount: parseFloat(this.ruleFrom.amount),
                        payPassword: md5(v)
                    }
                }
                this.$api
                    .withdrawApply(p)
                    .then((res) => {
                        this.tixianLoading = false
                        this.submitLoading = false
                        if (!res.success) {
                            this.$message.error(res.info)
                            return
                        }
                        this.dialogVisibles = true
                        this.dialogVisible = false
                        this.$store.dispatch('user/UserCenterStatistics')
                        this.ruleFrom.amount = null
                        this.$message.success(res.info)
                    })
                    .catch((_) => {
                        this.$message.error('出错啦')
                    })
            }
        },
        closeDialog() {
            this.submitLoading = false
        },
        submitForm() {
            console.log(this.ruleFrom.amount,'submitForm')
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    if (this.ruleFrom.amount < 10) {
                        this.$message.error('最低提现金额10元')
                        return
                    }
                    // 显示提现手续费
                    // this.getWithdrawFee()
                    // 显示支付密码模态框
                    this.dialogVisible = true
                    // 提交
                    this.submitLoading = true
                }
            })
        },
        getWithdrawFee() {
            let p = { action: { amount: parseFloat(this.ruleFrom.amount) } }
            this.$api.withdrawFee(p).then((res) => {
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                this.withdrawalFeePrice = res.data.withdrawalFee
            })
        }
    },
    mounted() {
        this.$store.dispatch('user/UserAccountAlipay')
        this.$store.dispatch('user/UserCheckAccountWhetherSetPayPass')
        this.$store.dispatch('user/UserCenterStatistics')
        this.$store.dispatch('user/UserGetInfo')
        this.ruleFrom.amount = this.toMoneyHandler(this.userAccount.balanceAmount)
    }
}
